import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { LoginButtonInterface } from 'src/shared/types/entities/login-button-interface'
import { BaseEditorButton } from '../base-editor-button'

export interface LoginButtonProps {
  entity: LoginButtonInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const LoginButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: LoginButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
